import '../index.css';
import Card from 'react-bootstrap/Card';

import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';



function ResultCard({before, after}) {

    
    return(
        <Card className='ResultCard m-3 shadow'  style={{overflow:"hidden", border:"2px solid", borderColor:"#D33D3D", color:"white"}}>
            
                <Tabs
                defaultActiveKey="1"
                className='tabMain'
                transition={false}
                justify
                style={{borderBottom:"2px solid", borderColor:"#D33D3D" }}
                >
                    <Tab className='resultTab' eventKey="1" title="After" >
                        <Card.Img  variant='bottom'  className='ResultImg' src={after} alt='' />
                    </Tab>
                    <Tab className='resultTab'  eventKey="2" title="Before" >
                        <Card.Img  variant='bottom' className='ResultImg' src={before} alt=''/>
                    </Tab>
                </Tabs>    
                           
        </Card>
    );
}

export default ResultCard;